import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";
import { FaPython, FaJava, FaHtml5, FaCss3Alt, FaGitAlt, FaReact, FaNodeJs, FaDatabase } from "react-icons/fa";
import { SiCplusplus, SiTailwindcss, SiTypescript, SiMongodb, SiMysql, SiPowerbi, SiIntellijidea, SiJavascript, SiAngular, SiAutodesk, SiJupyter, SiNotepadplusplus } from "react-icons/si";

const Experience = () => {
  return (
    <section id="experience">
      <h5>Check out</h5>
      <h2>My Skills</h2>
      <div className="container experience__container">
        
        {/* Programming */}
        <div className="experience__programming">
          <h3>Programming</h3>
          <div className="experience__content">
            <article className="experience__details">
              <FaPython className="experience__details-icon" />
              <div>
                <h4>Python</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiCplusplus className="experience__details-icon" />
              <div>
                <h4>C++</h4>
              </div>
            </article>
            <article className="experience__details">
              <FaJava className="experience__details-icon" />
              <div>
                <h4>Java</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>C</h4>
              </div>
            </article>
          </div>
        </div>

        {/* Frontend Development */}
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <SiAngular className="experience__details-icon" />
              <div>
                <h4>Angular</h4>
              </div>
            </article>
            <article className="experience__details">
              <FaReact className="experience__details-icon" />
              <div>
                <h4>React</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiJavascript className="experience__details-icon" />
              <div>
                <h4>JavaScript</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiTypescript className="experience__details-icon" />
              <div>
                <h4>TypeScript</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiTailwindcss className="experience__details-icon" />
              <div>
                <h4>Tailwind CSS</h4>
              </div>
            </article>
            <article className="experience__details">
              <FaHtml5 className="experience__details-icon" />
              <div>
                <h4>HTML</h4>
              </div>
            </article>
            <article className="experience__details">
              <FaCss3Alt className="experience__details-icon" />
              <div>
                <h4>CSS</h4>
              </div>
            </article>
          </div>
        </div>

        {/* Backend Development */}
        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <FaNodeJs className="experience__details-icon" />
              <div>
                <h4>Node.js</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiMongodb className="experience__details-icon" />
              <div>
                <h4>MongoDB</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiMysql className="experience__details-icon" />
              <div>
                <h4>MySQL</h4>
              </div>
            </article>
            <article className="experience__details">
              <FaDatabase className="experience__details-icon" />
              <div>
                <h4>SQL</h4>
              </div>
            </article>
          </div>
        </div>

        {/* Tools */}
        <div className="experience__tools">
          <h3>Tools</h3>
          <div className="experience__content">
            <article className="experience__details">
              <SiPowerbi className="experience__details-icon" />
              <div>
                <h4>PowerBI</h4>
              </div>
            </article>
            <article className="experience__details">
              <FaGitAlt className="experience__details-icon" />
              <div>
                <h4>Git & GitHub</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiAutodesk className="experience__details-icon" />
              <div>
                <h4>AutoCAD</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiIntellijidea className="experience__details-icon" />
              <div>
                <h4>IntelliJ IDEA</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiJupyter className="experience__details-icon" />
              <div>
                <h4>Jupyter Notebook</h4>
              </div>
            </article>
            <article className="experience__details">
              <SiNotepadplusplus className="experience__details-icon" />
              <div>
                <h4>Notepad++</h4>
              </div>
            </article>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Experience;
